import { createExtensionService } from '@tencent/ark-extensions';
import componentConfig from '@src/js/common/ark-extensions/dc-components/copy/component-config';
import {
    IDriveCloneOptions,
    IFileOperation,
    ILoopCloneOptions,
} from '@src/js/common/ark-extensions/dc-components/copy/interface';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import i18n from 'i18next';

/**
 * 生成副本（普通文档）
 */
export async function copyDoc(options?: Partial<ILoopCloneOptions>) {
    const { title, padId, mimeType, domainId } = getCopyCommonOptions();
    return (await getFileOperation()).loopClone({
        title,
        padId,
        domainId,
        mimeType,
        share: false,
        asyncClone: true,
        direct: true,
        ...options,
    });
}

/**
 * 生成副本（drive文档）
 */
export async function copyDrive(options?: Partial<IDriveCloneOptions>) {
    const { padId, title } = getCopyCommonOptions();
    return (await getFileOperation()).driveCloneAsync({
        padId,
        title,
        openAfterClone: true,
        ...options,
    });
}

function getCopyCommonOptions() {
    const titleManager = SlideDataServices.SlideTitleManager();
    const docInfoManager = SlideDataServices.DocInfoManager();

    return {
        title: i18n.t('副本-{0}', { 0: titleManager?.title || '' }),
        padId: docInfoManager?.padId || '',
        domainId: docInfoManager?.domainId || '',
        mimeType: docInfoManager?.docInfo?.mime_type || '',
    };
}

async function getFileOperation() {
    const extensionService = createExtensionService({
        metadataLoaderOptions: {
            specifiedVersion: 1,
        },
    });

    await extensionService.scanAndHandleExtensions([componentConfig]);
    return extensionService.getExtension<IFileOperation>(componentConfig.name);
}
